<template>
  <el-container  style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;margin-left: 3%;">

        <el-row :span="2" style="margin-top: 30px;">
            <el-col :span="8">
               <el-input v-model="seachName" style="width: 150px;" placeholder="请输入名称"></el-input>
               <el-button type="primary" style="background-color: #409eff;" @click="loadList()" round>搜索</el-button>
            </el-col>

        </el-row>
        <el-row :span="2" style="margin-top: 30px;">
            <div>
              <canvas ref="qrcodeCanvas"></canvas>
            </div>

        </el-row>

        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
            <el-table-column

              width="400"
              label="APK名称"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.name}}</div>

               </template>
            </el-table-column>
            <el-table-column

              width="300"
              label="备注"
               >
               <template slot-scope="scope">
                   <div @click="changePass(scope.row.content,scope.row.id,1)">{{scope.row.content}}</div>

               </template>
            </el-table-column>
            <el-table-column

              width="200"
              label="密码"
               >
               <template slot-scope="scope">
                 <div @click="changePass(scope.row.pass,scope.row.id,3)">{{scope.row.pass}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="200"
              label="过期时间"
               >
               <template slot-scope="scope">
                 <div <div @click="changePass(scope.row.overtime,scope.row.id,2)">{{scope.row.overtime}}</div>
               </template>
            </el-table-column>

            <el-table-column

              width="900"
              label="链接"
               >
               <template slot-scope="scope">
                 <div>{{scope.row.url}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="400"
              label="操作"
               >
               <template slot-scope="scope">
                 <el-row>
                   <el-col :span="8" style="text-align: center;margin-top: 15px;"  @click.native="copyLink(scope.row.url)">复制链接</el-col>

                   <el-col :span="8" style="text-align: center;margin-top: 15px;" @click.native="madeCode(scope.row.url)">生成二维码</el-col>

                 </el-row>

               </template>
            </el-table-column>


            </el-table>
          </template>
          <div class="page">
          	<el-pagination
          	  @size-change="loadList()"
          	  @current-change="loadList()"
          	  :current-page.sync="page"
          	  :page-size="15"
          	  background
          	  layout="total,prev, pager, next, jumper"
          	  :total="count">
          	</el-pagination>
          </div>
        </el-row>






    </el-row>
    <el-dialog
      title="修改"
      :visible.sync="disDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="names"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="dochangePass()">确 定</el-button>
      </span>
    </el-dialog>


  </el-container>
</template>
<script type="text/javascript" src="https://gosspublic.alicdn.com/aliyun-oss-sdk-6.18.0.min.js"></script>



<script>
  import './aliyun-oss-sdk-6.18.0.min.js'
  import QRCode from 'qrcode'
  import CryptoJS from 'crypto-js';
  export default {
    props: {
        link: {
          type: String,
          required: true
        }
      },
    mounted() {
      this.generateQRCode(this.link)
    },
    data() {
       return {

         page:1,
         count:0,
         list:[],
         name:'',
         names:'',
         disDialogVisible:false,
         passId:0,
         passt:0,
         seachName:'',







      }
    },
  directives: {
    },
    created() {

      this.loadList();
      // this.getUrl()
    },

  methods:{
    copyLink(urls){

        this.$copyText(urls).then(
          e => {
            this.msg('链接复制成功','success')
          },
          e => {
            this.msg('链接复制失败','error')
          }
        )
      // try {
      //   navigator.clipboard.writeText(urls);
      //   this.msg('链接复制成功','success')

      // } catch (err) {
      //   this.msg('链接复制失败','error')
      // }
    },

    changePass(n,id,t){
      this.passId = id
      this.passt = t
      this.names = n
      this.disDialogVisible = true
    },
    dochangePass(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          id:this.passId,
          t:this.passt,
          n:this.names
      	},
      	url:'http://ossp.yoooooo.com/index.php/index/data/changePass'
      })
      .then(res=>{

        this.disDialogVisible = false
        this.passId = 0
        this.passt = 0
        this.names = ''
        this.loadList()
      })
      .catch(err=>{

      });
    },

    madeCode(link){
      QRCode.toCanvas(this.$refs.qrcodeCanvas, link, error => {
        if (error) console.error(error)
      })
    },


    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          p:this.page,

      	},
      	url:'http://ossp.yoooooo.com/index.php/index/data/getLists'
      })
      .then(res=>{

        this.list = res.data.data;



      })
      .catch(err=>{

      });
    },





    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/lists.vue